export default __webpack_public_path__ + "static/media/img7.d060d18b.PNG";